import { Component, EventEmitter, Input, Output } from '@angular/core'
import { GenericLayer } from '../../../shared/model/layers/generic-layer'
import { SelectionLayer } from 'src/app/shared/model/layers/selection-layer'
import { GenericConfirmationDialogModel } from 'src/app/shared/components/generic-confirmation-dialog/generic-confirmation-dialog.model'
import { GenericConfirmationDialogComponent } from 'src/app/shared/components/generic-confirmation-dialog/generic-confirmation-dialog.component'
import { Dialog } from '@angular/cdk/dialog'
import { takeUntil } from 'rxjs/operators'
import { selectionActions } from 'src/app/state/selection/selection.actions'
import { Subject } from 'rxjs'
import { Store } from '@ngrx/store'
import { ToasterService } from 'src/app/shared/services/toaster.service'
import {
    RenameLayerDialogComponent,
    RenameLayerDialogData,
} from '../single-layer-detail/rename-layer-dialog/rename-layer-dialog.component'
import { SelectionType } from 'src/app/state/selection/selection.state'

@Component({
    selector: 'app-layer-group-detail',
    templateUrl: './layer-group-detail.component.html',
    styleUrls: ['./layer-group-detail.component.scss'],
})
export class LayerGroupDetailComponent {
    @Input()
    layers: GenericLayer[] | undefined | null

    @Input()
    title: string

    @Output()
    close = new EventEmitter<void>()

    private readonly destroy$ = new Subject<void>()

    opacityPercent = 100

    constructor(
        private readonly dialog: Dialog,
        private readonly store: Store,
        private readonly toasterService: ToasterService
    ) {}

    renameHierarchicalSelectionRoot(): void {
        const currentName = this.title

        const dialogData: RenameLayerDialogData = {
            currentName: currentName,
            layer: undefined,
            selectionType: (this.layers?.[0] as SelectionLayer)?.['_selection']?.type,
        }

        const dialogRef = this.dialog.open<string>(RenameLayerDialogComponent, {
            data: dialogData,
            autoFocus: 'first-tabbable',
        })

        dialogRef.closed.subscribe(newName => {
            if (newName) {
                this.toasterService.success(newName, 'Selection renamed successfully')
                this.title = newName
            }
        })
    }

    setLayerOpacity(newValue: number, oldValue: number): void {
        if (newValue === oldValue) return
        this.layers?.forEach(layer => {
            if (layer.opacityPercent) {
                layer.opacityPercent.setValue(newValue)
            }
        })
        this.opacityPercent = newValue
    }

    isHierarchicalSelection(): boolean {
        return this.layers?.find(layer => (layer as SelectionLayer).groupName) !== undefined
    }

    deleteHierarchicalSelectionRoot(): void {
        const selectionType = (this.layers?.[0] as SelectionLayer)?.['_selection']?.type
        const rootName = this.title
        const data: GenericConfirmationDialogModel = {
            title: `Are you sure you want to delete this ${
                selectionType === SelectionType.Hierarchical ? 'hierarchical' : 'unsupervised'
            } selection?`,
            item: rootName,
            confirmButtonLabel: 'Delete',
            cancelButtonLabel: 'Cancel',
        }
        const dialogRef = this.dialog.open<string>(GenericConfirmationDialogComponent, {
            data,
            autoFocus: 'dialog',
        })
        dialogRef.closed.pipe(takeUntil(this.destroy$)).subscribe(confirmed => {
            if (!confirmed) return
            this.store.dispatch(
                selectionType === SelectionType.Hierarchical
                    ? selectionActions.deleteHierarchicalSelectionRoot({ name: rootName })
                    : selectionActions.deleteAutoCellTypeDetectionRoot({ name: rootName })
            )
            this.toasterService.success(rootName, 'Selection deleted successfully')
            this.close.emit()
        })
    }
}
